export let CookieKeys = {
  XsrfToken: 'XSRF-TOKEN'
};
